const MOBILE_MQ = window.matchMedia('(max-width: 639px)');
const ITEM_H = 40;
const PAD_ITEMS = 2;
const WEEKDAY_LABELS = ['日', '月', '火', '水', '木', '金', '土'];

let sheetEl = null;
let calendarEl = null;
let activeValueInput = null;
let activeWrapper = null;
let activeTrigger = null;
let pickerState = { y: 0, m: 0, d: 0 };
let calendarView = { y: 0, m: 0 };
let suppressWheelSync = false;
let bodyScrollY = 0;
let touchMoveGuardBound = false;
let globalListenersBound = false;

function pad2(n) {
  return String(n).padStart(2, '0');
}

function parseIso(value) {
  if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const [y, m, d] = value.split('-').map(Number);
  return { y, m, d };
}

function daysInMonth(y, m) {
  return new Date(y, m, 0).getDate();
}

function clampDateParts(y, m, d, minIso, maxIso) {
  let date = new Date(y, m - 1, d);
  const min = parseIso(minIso);
  const max = parseIso(maxIso);
  if (min) {
    const minD = new Date(min.y, min.m - 1, min.d);
    if (date < minD) date = minD;
  }
  if (max) {
    const maxD = new Date(max.y, max.m - 1, max.d);
    if (date > maxD) date = maxD;
  }
  return { y: date.getFullYear(), m: date.getMonth() + 1, d: date.getDate() };
}

function formatJa(y, m, d) {
  return `${y}年${m}月${d}日`;
}

function formatIso(y, m, d) {
  return `${y}-${pad2(m)}-${pad2(d)}`;
}

function formatShort(y, m, d) {
  return `${y}/${pad2(m)}/${pad2(d)}`;
}

function getBounds(wrapper) {
  const min = wrapper.dataset.min || '';
  const max = wrapper.dataset.max || '';
  const now = new Date();
  const fallbackMin = { y: now.getFullYear() - 5, m: 1, d: 1 };
  const fallbackMax = { y: now.getFullYear(), m: 12, d: 31 };
  const minP = parseIso(min) || fallbackMin;
  const maxP = parseIso(max) || fallbackMax;
  return { minIso: min, maxIso: max, minP, maxP };
}

function yearRange(minP, maxP) {
  const years = [];
  for (let y = minP.y; y <= maxP.y; y += 1) years.push(y);
  return years;
}

function monthRange(y, minP, maxP, minIso, maxIso) {
  let start = 1;
  let end = 12;
  if (minIso && y === minP.y) start = minP.m;
  if (maxIso && y === maxP.y) end = maxP.m;
  const months = [];
  for (let m = start; m <= end; m += 1) months.push(m);
  return months;
}

function dayRange(y, m, minP, maxP, minIso, maxIso) {
  let start = 1;
  let end = daysInMonth(y, m);
  if (minIso && y === minP.y && m === minP.m) start = minP.d;
  if (maxIso && y === maxP.y && m === maxP.m) end = maxP.d;
  const days = [];
  for (let d = start; d <= end; d += 1) days.push(d);
  return days;
}

function updateTriggerLabel(valueInput, trigger) {
  if (!valueInput || !trigger) return;
  const label = trigger.querySelector('[data-date-scroll-label]') || trigger;
  const p = parseIso(valueInput.value);
  if (!p) {
    label.textContent = '日付を選択';
    trigger.classList.add('text-gray-400');
    trigger.classList.remove('text-gray-800');
    return;
  }
  label.textContent = formatShort(p.y, p.m, p.d);
  trigger.classList.remove('text-gray-400');
  trigger.classList.add('text-gray-800');
}

function updateFieldTriggers(wrapper) {
  const valueInput = wrapper.querySelector('[data-date-scroll-value]');
  wrapper.querySelectorAll('[data-date-scroll-trigger], [data-date-scroll-desktop-trigger]').forEach((trigger) => {
    updateTriggerLabel(valueInput, trigger);
  });
}

function onSheetTouchMove(event) {
  if (event.target.closest('[data-wheel]')) return;
  event.preventDefault();
}

function lockBodyScroll() {
  bodyScrollY = window.scrollY || window.pageYOffset || 0;
  document.body.classList.add('date-scroll-picker-open');
  document.body.style.top = `-${bodyScrollY}px`;
  if (!touchMoveGuardBound && sheetEl) {
    sheetEl.addEventListener('touchmove', onSheetTouchMove, { passive: false });
    touchMoveGuardBound = true;
  }
}

function unlockBodyScroll() {
  document.body.classList.remove('date-scroll-picker-open');
  document.body.style.top = '';
  window.scrollTo(0, bodyScrollY);
  if (touchMoveGuardBound && sheetEl) {
    sheetEl.removeEventListener('touchmove', onSheetTouchMove);
    touchMoveGuardBound = false;
  }
}

function buildWheelItems(wheel, values, markerDay = null) {
  wheel.innerHTML = '';
  for (let i = 0; i < PAD_ITEMS; i += 1) {
    const pad = document.createElement('div');
    pad.className = 'date-scroll-picker-wheel-item date-scroll-picker-wheel-item--pad';
    pad.setAttribute('aria-hidden', 'true');
    wheel.appendChild(pad);
  }
  values.forEach((val) => {
    const item = document.createElement('div');
    item.className = 'date-scroll-picker-wheel-item';
    if (markerDay !== null && Number(val) === Number(markerDay)) {
      item.classList.add('date-scroll-picker-wheel-item--marker');
    }
    item.dataset.value = String(val);
    item.textContent = String(val);
    wheel.appendChild(item);
  });
  for (let i = 0; i < PAD_ITEMS; i += 1) {
    const pad = document.createElement('div');
    pad.className = 'date-scroll-picker-wheel-item date-scroll-picker-wheel-item--pad';
    pad.setAttribute('aria-hidden', 'true');
    wheel.appendChild(pad);
  }
}

function markerDayForMonth(wrapper, y, m) {
  if (!wrapper) return null;
  const marker = parseIso(wrapper.dataset.markerDate || '');
  if (!marker) return null;
  if (marker.y === y && marker.m === m) return marker.d;
  return null;
}

function scrollWheelToValue(wheel, values, selected) {
  const idx = Math.max(0, values.indexOf(selected));
  wheel.scrollTop = idx * ITEM_H;
}

function applyWheelScrollPositions(initial, minIso, maxIso, minP, maxP) {
  if (!sheetEl) return;
  const yearWheel = sheetEl.querySelector('[data-wheel="year"]');
  const monthWheel = sheetEl.querySelector('[data-wheel="month"]');
  const dayWheel = sheetEl.querySelector('[data-wheel="day"]');
  const years = yearRange(minP, maxP);
  const months = monthRange(initial.y, minP, maxP, minIso, maxIso);
  const days = dayRange(initial.y, initial.m, minP, maxP, minIso, maxIso);

  suppressWheelSync = true;
  scrollWheelToValue(yearWheel, years, initial.y);
  scrollWheelToValue(monthWheel, months, initial.m);
  scrollWheelToValue(dayWheel, days, initial.d);
  window.requestAnimationFrame(() => {
    scrollWheelToValue(yearWheel, years, initial.y);
    scrollWheelToValue(monthWheel, months, initial.m);
    scrollWheelToValue(dayWheel, days, initial.d);
    suppressWheelSync = false;
  });
}

function readWheelValue(wheel) {
  const idx = Math.round(wheel.scrollTop / ITEM_H);
  const items = Array.from(wheel.querySelectorAll('.date-scroll-picker-wheel-item:not(.date-scroll-picker-wheel-item--pad)'));
  const item = items[idx];
  return item ? Number(item.dataset.value) : null;
}

function syncPickerFromWheels() {
  if (!activeWrapper) return;
  const sheet = ensureSheet();
  const { minIso, maxIso, minP, maxP } = getBounds(activeWrapper);
  const yearWheel = sheet.querySelector('[data-wheel="year"]');
  const monthWheel = sheet.querySelector('[data-wheel="month"]');
  const dayWheel = sheet.querySelector('[data-wheel="day"]');

  let y = readWheelValue(yearWheel) ?? pickerState.y;
  let m = readWheelValue(monthWheel) ?? pickerState.m;
  let d = readWheelValue(dayWheel) ?? pickerState.d;

  const months = monthRange(y, minP, maxP, minIso, maxIso);
  if (!months.includes(m)) m = months[months.length - 1];

  const days = dayRange(y, m, minP, maxP, minIso, maxIso);
  if (!days.includes(d)) d = days[days.length - 1];

  const clamped = clampDateParts(y, m, d, minIso, maxIso);
  pickerState = clamped;

  const years = yearRange(minP, maxP);
  if (readWheelValue(yearWheel) !== clamped.y) {
    buildWheelItems(yearWheel, years);
    scrollWheelToValue(yearWheel, years, clamped.y);
  }
  const months2 = monthRange(clamped.y, minP, maxP, minIso, maxIso);
  if (readWheelValue(monthWheel) !== clamped.m || monthWheel.dataset.builtForYear !== String(clamped.y)) {
    buildWheelItems(monthWheel, months2);
    monthWheel.dataset.builtForYear = String(clamped.y);
    scrollWheelToValue(monthWheel, months2, clamped.m);
  }
  const days2 = dayRange(clamped.y, clamped.m, minP, maxP, minIso, maxIso);
  if (readWheelValue(dayWheel) !== clamped.d || dayWheel.dataset.builtForMonth !== `${clamped.y}-${clamped.m}`) {
    buildWheelItems(dayWheel, days2, markerDayForMonth(activeWrapper, clamped.y, clamped.m));
    dayWheel.dataset.builtForMonth = `${clamped.y}-${clamped.m}`;
    scrollWheelToValue(dayWheel, days2, clamped.d);
  }
}

function renderPickerTitle() {
  if (!sheetEl) return;
  const title = sheetEl.querySelector('[data-title]');
  title.textContent = formatJa(pickerState.y, pickerState.m, pickerState.d);
}

function ensureSheet() {
  if (sheetEl) return sheetEl;

  sheetEl = document.createElement('div');
  sheetEl.className = 'date-scroll-picker-sheet hidden';
  sheetEl.innerHTML = `
    <div class="date-scroll-picker-backdrop" data-close></div>
    <div class="date-scroll-picker-panel" role="dialog" aria-modal="true" aria-label="日付を選択">
      <div class="date-scroll-picker-header">
        <p class="date-scroll-picker-title" data-title>日付を選択</p>
        <button type="button" class="date-scroll-picker-done" data-done>完了</button>
      </div>
      <div class="date-scroll-picker-wheels">
        <div class="date-scroll-picker-wheel-wrap">
          <div class="date-scroll-picker-wheel" data-wheel="year" tabindex="-1"></div>
          <span class="date-scroll-picker-unit">年</span>
        </div>
        <div class="date-scroll-picker-wheel-wrap">
          <div class="date-scroll-picker-wheel" data-wheel="month" tabindex="-1"></div>
          <span class="date-scroll-picker-unit">月</span>
        </div>
        <div class="date-scroll-picker-wheel-wrap">
          <div class="date-scroll-picker-wheel" data-wheel="day" tabindex="-1"></div>
          <span class="date-scroll-picker-unit">日</span>
        </div>
        <div class="date-scroll-picker-highlight" aria-hidden="true"></div>
      </div>
    </div>
  `;
  document.body.appendChild(sheetEl);

  sheetEl.querySelector('[data-close]').addEventListener('click', closePicker);
  sheetEl.querySelector('[data-done]').addEventListener('click', commitPicker);

  sheetEl.querySelectorAll('[data-wheel]').forEach((wheel) => {
    let scrollTimer = null;
    wheel.addEventListener('scroll', () => {
      if (suppressWheelSync) return;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        syncPickerFromWheels();
        renderPickerTitle();
      }, 80);
    }, { passive: true });
  });

  return sheetEl;
}

function openPicker(valueInput, trigger, wrapper) {
  if (!MOBILE_MQ.matches) return;
  closeDesktopCalendar();
  activeValueInput = valueInput;
  activeWrapper = wrapper;
  activeTrigger = trigger;
  const sheet = ensureSheet();
  const { minIso, maxIso, minP, maxP } = getBounds(wrapper);

  const parsed = parseIso(valueInput.value);
  const initial = clampDateParts(
    parsed ? parsed.y : maxP.y,
    parsed ? parsed.m : maxP.m,
    parsed ? parsed.d : maxP.d,
    minIso,
    maxIso
  );
  pickerState = initial;

  const yearWheel = sheet.querySelector('[data-wheel="year"]');
  const monthWheel = sheet.querySelector('[data-wheel="month"]');
  const dayWheel = sheet.querySelector('[data-wheel="day"]');

  buildWheelItems(yearWheel, yearRange(minP, maxP));
  buildWheelItems(monthWheel, monthRange(initial.y, minP, maxP, minIso, maxIso));
  monthWheel.dataset.builtForYear = String(initial.y);
  buildWheelItems(
    dayWheel,
    dayRange(initial.y, initial.m, minP, maxP, minIso, maxIso),
    markerDayForMonth(wrapper, initial.y, initial.m)
  );
  dayWheel.dataset.builtForMonth = `${initial.y}-${initial.m}`;

  renderPickerTitle();
  sheet.classList.remove('hidden');
  lockBodyScroll();

  window.requestAnimationFrame(() => {
    applyWheelScrollPositions(initial, minIso, maxIso, minP, maxP);
  });
}

function closePicker() {
  if (!sheetEl) return;
  sheetEl.classList.add('hidden');
  unlockBodyScroll();
  activeValueInput = null;
  activeWrapper = null;
  activeTrigger = null;
}

function commitPicker() {
  if (!activeValueInput || !activeWrapper) {
    closePicker();
    return;
  }
  syncPickerFromWheels();
  activeValueInput.value = formatIso(pickerState.y, pickerState.m, pickerState.d);
  updateFieldTriggers(activeWrapper);
  activeValueInput.dispatchEvent(new Event('input', { bubbles: true }));
  activeValueInput.dispatchEvent(new Event('change', { bubbles: true }));
  closePicker();
}

function ensureDesktopCalendar() {
  if (calendarEl) return calendarEl;

  calendarEl = document.createElement('div');
  calendarEl.className = 'date-month-calendar hidden';
  calendarEl.innerHTML = `
    <div class="date-month-calendar-panel" role="dialog" aria-label="日付を選択">
      <div class="date-month-calendar-header">
        <button type="button" class="date-month-calendar-nav" data-cal-prev aria-label="前月">‹</button>
        <p class="date-month-calendar-title" data-cal-title></p>
        <button type="button" class="date-month-calendar-nav" data-cal-next aria-label="次月">›</button>
      </div>
      <div class="date-month-calendar-weekdays" data-cal-weekdays></div>
      <div class="date-month-calendar-grid" data-cal-grid></div>
    </div>
  `;
  document.body.appendChild(calendarEl);

  const weekdays = calendarEl.querySelector('[data-cal-weekdays]');
  WEEKDAY_LABELS.forEach((label) => {
    const el = document.createElement('span');
    el.textContent = label;
    weekdays.appendChild(el);
  });

  calendarEl.querySelector('[data-cal-prev]').addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    shiftCalendarMonth(-1);
  });
  calendarEl.querySelector('[data-cal-next]').addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    shiftCalendarMonth(1);
  });

  document.addEventListener('click', (event) => {
    if (!calendarEl || calendarEl.classList.contains('hidden')) return;
    if (calendarEl.contains(event.target)) return;
    if (event.target.closest('[data-date-scroll-desktop-trigger]')) return;
    closeDesktopCalendar();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDesktopCalendar();
  });

  return calendarEl;
}

function shiftCalendarMonth(delta) {
  if (!activeWrapper) return;
  const { minP, maxP } = getBounds(activeWrapper);
  let y = calendarView.y;
  let m = calendarView.m + delta;
  if (m < 1) {
    m = 12;
    y -= 1;
  } else if (m > 12) {
    m = 1;
    y += 1;
  }
  if (y < minP.y || (y === minP.y && m < minP.m)) return;
  if (y > maxP.y || (y === maxP.y && m > maxP.m)) return;
  calendarView = { y, m };
  renderDesktopCalendarGrid();
}

function isDateInRange(y, m, d, minIso, maxIso) {
  const iso = formatIso(y, m, d);
  if (minIso && iso < minIso) return false;
  if (maxIso && iso > maxIso) return false;
  return true;
}

function renderDesktopCalendarGrid() {
  if (!calendarEl || !activeWrapper) return;
  const { minIso, maxIso } = getBounds(activeWrapper);
  const marker = parseIso(activeWrapper.dataset.markerDate || '');
  const selected = parseIso(activeValueInput?.value || '');
  const title = calendarEl.querySelector('[data-cal-title]');
  const grid = calendarEl.querySelector('[data-cal-grid]');
  title.textContent = `${calendarView.y}年${calendarView.m}月`;
  grid.innerHTML = '';

  const firstDow = new Date(calendarView.y, calendarView.m - 1, 1).getDay();
  const totalDays = daysInMonth(calendarView.y, calendarView.m);

  for (let i = 0; i < firstDow; i += 1) {
    const empty = document.createElement('span');
    empty.className = 'date-month-calendar-day date-month-calendar-day--empty';
    grid.appendChild(empty);
  }

  for (let d = 1; d <= totalDays; d += 1) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'date-month-calendar-day';
    btn.textContent = String(d);
    const enabled = isDateInRange(calendarView.y, calendarView.m, d, minIso, maxIso);
    if (!enabled) {
      btn.disabled = true;
      btn.classList.add('date-month-calendar-day--disabled');
    }
    if (marker && marker.y === calendarView.y && marker.m === calendarView.m && marker.d === d) {
      btn.classList.add('date-month-calendar-day--marker');
      btn.title = 'Genegram接続日';
    }
    if (selected && selected.y === calendarView.y && selected.m === calendarView.m && selected.d === d) {
      btn.classList.add('date-month-calendar-day--selected');
    }
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (!enabled || !activeValueInput || !activeWrapper) return;
      activeValueInput.value = formatIso(calendarView.y, calendarView.m, d);
      updateFieldTriggers(activeWrapper);
      activeValueInput.dispatchEvent(new Event('input', { bubbles: true }));
      activeValueInput.dispatchEvent(new Event('change', { bubbles: true }));
      closeDesktopCalendar();
    });
    grid.appendChild(btn);
  }
}

function positionDesktopCalendar(anchor) {
  if (!calendarEl) return;
  const panel = calendarEl.querySelector('.date-month-calendar-panel');
  const rect = anchor.getBoundingClientRect();
  const panelWidth = 288;
  let left = rect.left + window.scrollX;
  const top = rect.bottom + window.scrollY + 6;
  const maxLeft = window.scrollX + document.documentElement.clientWidth - panelWidth - 8;
  if (left > maxLeft) left = Math.max(8, maxLeft);
  panel.style.left = `${left}px`;
  panel.style.top = `${top}px`;
}

function openDesktopCalendar(valueInput, trigger, wrapper) {
  if (MOBILE_MQ.matches) return;
  closePicker();
  activeValueInput = valueInput;
  activeWrapper = wrapper;
  activeTrigger = trigger;
  const cal = ensureDesktopCalendar();
  const { minIso, maxIso, maxP } = getBounds(wrapper);
  const parsed = parseIso(valueInput.value);
  const marker = parseIso(wrapper.dataset.markerDate || '');
  const initial = clampDateParts(
    parsed ? parsed.y : (marker ? marker.y : maxP.y),
    parsed ? parsed.m : (marker ? marker.m : maxP.m),
    parsed ? parsed.d : (marker ? marker.d : maxP.d),
    minIso,
    maxIso
  );
  calendarView = { y: initial.y, m: initial.m };
  renderDesktopCalendarGrid();
  cal.classList.remove('hidden');
  positionDesktopCalendar(trigger);
}

function closeDesktopCalendar() {
  if (!calendarEl) return;
  calendarEl.classList.add('hidden');
  if (!sheetEl || sheetEl.classList.contains('hidden')) {
    activeValueInput = null;
    activeWrapper = null;
    activeTrigger = null;
  }
}

function bindTriggerDelegation() {
  if (document.documentElement.dataset.dateScrollDelegation === '1') return;
  document.documentElement.dataset.dateScrollDelegation = '1';

  let lastTouchAt = 0;
  let lastOpenAt = 0;

  const tryOpenMobile = (trigger, event) => {
    if (!MOBILE_MQ.matches) return;
    event.preventDefault();
    event.stopPropagation();

    const now = Date.now();
    if (now - lastOpenAt < 350) return;
    lastOpenAt = now;

    const wrapper = trigger.closest('[data-date-scroll-picker]');
    const valueInput = wrapper?.querySelector('[data-date-scroll-value]');
    if (!wrapper || !valueInput) return;

    openPicker(valueInput, trigger, wrapper);
  };

  document.addEventListener('touchend', (event) => {
    const trigger = event.target.closest('[data-date-scroll-trigger]');
    if (!trigger) return;
    lastTouchAt = Date.now();
    tryOpenMobile(trigger, event);
  }, { passive: false, capture: true });

  document.addEventListener('click', (event) => {
    const mobileTrigger = event.target.closest('[data-date-scroll-trigger]');
    if (mobileTrigger) {
      if (Date.now() - lastTouchAt < 500) return;
      tryOpenMobile(mobileTrigger, event);
      return;
    }

    const desktopTrigger = event.target.closest('[data-date-scroll-desktop-trigger]');
    if (!desktopTrigger) return;
    event.preventDefault();
    event.stopPropagation();
    const wrapper = desktopTrigger.closest('[data-date-scroll-picker]');
    const valueInput = wrapper?.querySelector('[data-date-scroll-value]');
    if (!wrapper || !valueInput) return;
    openDesktopCalendar(valueInput, desktopTrigger, wrapper);
  }, true);
}

function enhanceField(wrapper) {
  if (wrapper.dataset.dateScrollEnhanced === '1') return;
  const valueInput = wrapper.querySelector('[data-date-scroll-value]');
  if (!valueInput) return;
  wrapper.dataset.dateScrollEnhanced = '1';
  updateFieldTriggers(wrapper);
}

function initDateScrollPickers() {
  bindTriggerDelegation();
  document.querySelectorAll('[data-date-scroll-picker]').forEach(enhanceField);
}

function refreshTriggerLabels() {
  document.querySelectorAll('[data-date-scroll-picker]').forEach((wrapper) => {
    updateFieldTriggers(wrapper);
  });
}

function bindGlobalListeners() {
  if (globalListenersBound) return;
  globalListenersBound = true;

  document.addEventListener('click', (event) => {
    const resetBtn = event.target.closest('.js-period-reset-btn');
    if (!resetBtn) return;
    const form = resetBtn.closest('form');
    if (form) {
      form.querySelectorAll('[data-date-scroll-value]').forEach((input) => {
        input.value = '';
      });
    }
    window.setTimeout(refreshTriggerLabels, 0);
  });

  document.querySelectorAll('input[name="dashboardMode"]').forEach((input) => {
    input.addEventListener('change', () => {
      window.setTimeout(initDateScrollPickers, 50);
    });
  });

  window.addEventListener('resize', () => {
    if (!calendarEl || calendarEl.classList.contains('hidden') || !activeTrigger) return;
    positionDesktopCalendar(activeTrigger);
  });
}

function bootDateScrollPickers() {
  initDateScrollPickers();
  bindGlobalListeners();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootDateScrollPickers);
} else {
  bootDateScrollPickers();
}

MOBILE_MQ.addEventListener('change', () => {
  closePicker();
  closeDesktopCalendar();
  document.querySelectorAll('[data-date-scroll-picker]').forEach((wrapper) => {
    delete wrapper.dataset.dateScrollEnhanced;
  });
  initDateScrollPickers();
});

export { initDateScrollPickers, refreshTriggerLabels };

window.refreshDateScrollPickerLabels = refreshTriggerLabels;
window.initDateScrollPickers = initDateScrollPickers;
